import React, {Fragment, useCallback, useState} from "react";
import {Confirm, Create, Edit, SimpleForm, TextInput, useNotify, Button, TopToolbar, ShowButton} from 'react-admin';
import {API_URL} from "../data-providers/vms";


const RecordTitle = ({record}) => (
    <span>Record {record ? `"${record.slug || record.name}"` : ''}</span>
);

const CollectionForm = (props) => {
    return (
        <SimpleForm {...props} >
            <TextInput readOnly label="Id" source="id"/>
            <TextInput readOnly label="slug" source="slug"/>
            <TextInput source="title"/>
            <TextInput source="description"/>
            <TextInput readOnly label="Created date" source="createdAt"/>
            <TextInput readOnly label="Updated date" source="updatedAt"/>
            <PublishButton {...props}/>
        </SimpleForm>
    );
}
const PublishButton = (props) => {
    const notify = useNotify();
    const [open, setOpen] = useState(false);
    const handleConfirm = useCallback(() => {
        setOpen(false);
        console.log("Props: ", props);
        notify('Publishing collection ' + props.record.slug);
        fetch(API_URL + '/collections/publish/' + props.record.slug, {
            method: 'POST',
            headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`}
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                notify('Publish error. Refer to console.log for details');
            }
        }).then(body => {
            notify('Publish success: ' + JSON.stringify(body));
        }).catch(err => {
            notify('Unable to publish: ' + err.message);
        })
    })

    return (
        <Fragment>
            <Button label={"Publish This Collection"} onClick={() => setOpen(true)}
                    disabled={!props.record.id || !props.record.slug}
            />
            <Confirm isOpen={open}
                     title={'Publish This Collection?'}
                     content={`Are you sure you want to copy ALL movies in this collection to published?? This action can not be undone!`}
                     onConfirm={handleConfirm}
                     onClose={() => setOpen(false)}
            />
        </Fragment>
    )
}


export const CollectionEdit = (props) => (
    <Edit title={<RecordTitle/>}  {...props} >
        <CollectionForm/>
    </Edit>
);


export const CollectionCreate = (props) => (
    <Create title="New Collection/Import" {...props} >
        <SimpleForm {...props} >
            <TextInput source="title"/>
            <TextInput source="description"/>
        </SimpleForm>
    </Create>
);
